/* eslint-disable camelcase */
import { StyledReactSelect } from '@fountain/fountain-ui-components';
import { Grid } from '@material-ui/core';
import { produce } from 'immer';
import React, { FC, useContext } from 'react';
import { useIntl } from 'react-intl';

import { getConditionErrorMessage } from 'containers/WorkflowEditor/components/Rules/Condition/constants';
import { RulesEditDataContext } from 'containers/WorkflowEditor/contexts/rulesEditDataContext';

import { DocumentSigningRuleProps } from '../../../DocumentSigningRules/types';
import {
  PartnerRuleProps,
  SharedPartnerConditionProps,
} from '../../../PartnerRules/types';
import { RulesProps, SharedConditionProps } from '../../../types';
import { messages } from './messages';

export const PartnerDetailSelect: FC<
  SharedConditionProps | SharedPartnerConditionProps
> = ({
  condition,
  ruleId,
  setRules,
  setPartnerRules,
  setDocumentSigningRules,
  errors,
}) => {
  const intl = useIntl();
  const { partner_detail_keys: partnerDetailKeys } =
    useContext(RulesEditDataContext);
  const { extra } = condition;

  const associatedPartnerDetails = partnerDetailKeys?.filter(
    detail => detail.partner_id === extra?.partner_id,
  );

  const onChangePartnerDetail = (partnerDetail: {
    label: string;
    value: string;
    partner_id: string;
  }) => {
    const rulesSetter = setRules ?? setDocumentSigningRules;

    if (rulesSetter) {
      rulesSetter(
        produce((draftRules: RulesProps | DocumentSigningRuleProps) => {
          const draftConditions =
            draftRules[ruleId]?.condition_set_attributes
              ?.conditions_attributes ?? [];

          const idx = draftConditions.findIndex(
            cond => cond.id === condition.id,
          );

          draftConditions[idx].extra.key = partnerDetail.value;
        }),
      );
    }

    if (setPartnerRules) {
      setPartnerRules(
        produce((draftRules: PartnerRuleProps) => {
          const draftCondition = draftRules[ruleId].condition_attributes;

          draftCondition.extra.key = partnerDetail.value;
        }),
      );
    }
  };

  const partnerDetailOptions = setPartnerRules
    ? partnerDetailKeys
    : associatedPartnerDetails;

  const selectedPartnerDetail =
    partnerDetailOptions?.find(option => option.value === extra.key) ?? null;

  const keyErrorMessage =
    !extra?.key && getConditionErrorMessage('key', errors);

  return (
    <Grid item xs={6}>
      <StyledReactSelect
        options={partnerDetailOptions}
        value={selectedPartnerDetail}
        onChange={onChangePartnerDetail}
        label={intl.formatMessage(messages.partnerDetail)}
        aria-label={intl.formatMessage(messages.partnerDetail)}
        isSearchable
        error={keyErrorMessage}
        placeholder=""
        required
      />
    </Grid>
  );
};
